import axios, { AxiosPromise } from 'axios';

import { IFarm } from '../../../@types/model/masterData/farm/farm';
import qs from 'qs';
import { IFarmUpsert } from '../../../@types/model/masterData/farm/farmUpsert';

export default class FarmHttpService {
    public static getFarmData(organizationIds ?: Array<number>, onlyActive ?: boolean, ignoreIncludes ?: boolean) : AxiosPromise<Array<IFarm>> {
        return axios.get(`${API_URL}/v1/Farm/GetAllWeb`, {
            params: {
                onlyActive,
                ignoreIncludes,
                organizationIds,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static addOrUpdateFarm(upsert : IFarmUpsert) : AxiosPromise<IFarm> {
        return axios.post(`${API_URL}/v1/Farm/PostFarm`, upsert);
    }

    public static deleteFarm(farmId : number) : AxiosPromise<IFarm> {
        return axios.delete(`${API_URL}/v1/Farm/Delete`, {
            params : { farmId },
        });
    }
}
